import $ from 'jquery'
import batchItemTemplate from 'templates/store/batch-item.pug'
import feedbackErrorsTemplate from 'templates/feedback/errors.pug'

import BaseComponent from 'scripts/components/base-component'
import { showSpinner, hideSpinner } from 'scripts/utils/spinner'

class StoreBatch extends BaseComponent {
  static componentName = 'store-batch'

  static DOMEvents = {
    'click [data-toggle-container]': 'onToggleLinkClick'
  }

  static emitterEvents = {
    'batch-search:success': 'onBatchSearchSuccess'
  }

  constructor ($element, options = {}) {
    super($element)

    this.options = options
  }

  init () {
    this.setupElements()
  }

  setupElements () {
    this.$batchesContainer = this.$element.find('[data-store-batch-container]')
    this.$elementToggleLink = this.$element.find('[data-toggle-container]')
  }

  onToggleLinkClick () {
    if (this.batchFetched) {
      this.toggleBatchContainer()
      this.toggleTittle()
    } else {
      this.fetchStoreBatches()
    }
  }

  onBatchSearchSuccess () {
    this.$element.removeClass('hidden')
  }

  fetchStoreBatches () {
    const { lm, storeSlug } = this.options
    const url = `/hybris/stock/${lm}/${storeSlug}`

    showSpinner()

    $.get(url)
      .done(this.onFetchStoreBatchesSuccess.bind(this))
      .fail(this.onFetchStoreBatchesFailure.bind(this))
      .always(hideSpinner)
  }

  onFetchStoreBatchesSuccess (response) {
    if (response.errors && response.errors.length) {
      return this.onFetchStoreBatchesFailure()
    }

    this.populateBatchTable(response)
    this.batchFetched = true

    this.toggleBatchContainer()
    this.toggleTittle()
  }

  onFetchStoreBatchesFailure ({ responseJSON }) {
    this.clearErrors()
    const { errors } = responseJSON

    $('[data-batch-errors]').append(feedbackErrorsTemplate({ errors }))
  }

  populateBatchTable (data) {
    this.$batchesContainer.html(
      batchItemTemplate(data)
    )
  }

  toggleBatchContainer () {
    this.$batchesContainer.toggleClass('active')
  }

  toggleTittle () {
    const isActive = this.$batchesContainer.hasClass('active')
    const titleSlice = isActive ? 'Ocultar' : 'Ver mais'

    this.$elementToggleLink.text(`${titleSlice} lotes de sua loja`)
  }

  clearErrors () {
    $('[data-batch-errors]').empty()
  }
}

export default ($el) => new StoreBatch($el, $el.data()).init()

export { StoreBatch as Component }
